
// GuardList.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Card,
  CardBody,
} from "reactstrap";
import { getAllGuardLocations } from "../../store/actions";
import { createSelector } from "reselect";
import GuardLocationTable from "./gaurdVehicleLocationList2";

export default function GuardList() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("guards");

  const locationsSelector = createSelector(
    (state) => state.Common,
    (Common) => Common.location
  );
  const locations = useSelector(locationsSelector);

  useEffect(() => {
    dispatch(getAllGuardLocations());
  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Row>
          <Col>
            <Card className="shadow-sm">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4 className="card-title mb-0">Location Tracking</h4>
                  <div className="d-flex align-items-center">
                    <div className="status-legend d-flex align-items-center gap-3">
                      <div className="d-flex align-items-center">
                        <span
                          className="status-dot me-2"
                          style={{ backgroundColor: "green" }}
                        ></span>
                        <small className="text-muted">Online (1hr)</small>
                      </div>
                      <div className="d-flex align-items-center">
                        <span
                          className="status-dot me-2"
                          style={{ backgroundColor: "orange" }}
                        ></span>
                        <small className="text-muted">Away (1.5d)</small>
                      </div>
                      <div className="d-flex align-items-center">
                        <span
                          className="status-dot me-2"
                          style={{ backgroundColor: "red" }}
                        ></span>
                        <small className="text-muted">Offline</small>
                      </div>
                    </div>
                  </div>
                </div>

                <Nav tabs className="nav-tabs-custom">
                  <NavItem>
                    <NavLink
                      className={`nav-link-custom ${
                        activeTab === "guards" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("guards")}
                    >
                      <i className="fas fa-user-shield me-2"></i>
                      Guards
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={`nav-link-custom ${
                        activeTab === "vehicles" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("vehicles")}
                    >
                      <i className="fas fa-car me-2"></i>
                      Vehicles
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={activeTab} className="mt-3">
                  <TabPane tabId="guards">
                    <GuardLocationTable
                      locations={locations?.usersWithLocation}
                      type="guards"
                    />
                  </TabPane>
                  <TabPane tabId="vehicles">
                    <GuardLocationTable
                      locations={locations?.vehicleWithLocation}
                      type="vehicles"
                    />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        .status-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          display: inline-block;
        }
        
        .nav-tabs-custom {
          border-bottom: 2px solid #e9ecef;
        }
        
        .nav-link-custom {
          cursor: pointer;
          padding: 12px 24px;
          border: none;
          background: transparent;
          color: #6c757d;
          font-weight: 500;
          transition: all 0.3s ease;
          border-radius: 8px 8px 0 0;
        }
        
        .nav-link-custom:hover {
          background-color: #f8f9fa;
          color: #495057;
        }
        
        .nav-link-custom.active {
          background-color: #007bff;
          color: white;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}